/**
 * @generated SignedSource<<040409f53f3296cb21d07da86c820278>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HomeInstagramQuery$variables = {
  bannerId: string;
  includeBanner: boolean;
  instagramId: string;
  pageName: string;
};
export type HomeInstagramQuery$data = {
  readonly banner?: {
    readonly contentType: string;
    readonly height: number | null | undefined;
    readonly id: string;
    readonly playlistUrl: string | null | undefined;
    readonly width: number | null | undefined;
  } | null | undefined;
  readonly instagramAccount: {
    readonly media: ReadonlyArray<{
      readonly id: string;
      readonly permalink: string;
      readonly timestamp: any;
    }>;
  } | null | undefined;
  readonly page: {
    readonly banners: ReadonlyArray<{
      readonly contentType: string;
      readonly height: number | null | undefined;
      readonly id: string;
      readonly playlistUrl: string | null | undefined;
      readonly width: number | null | undefined;
    }>;
    readonly content: string | null | undefined;
    readonly title: string | null | undefined;
    readonly titleColor: string | null | undefined;
  } | null | undefined;
};
export type HomeInstagramQuery = {
  response: HomeInstagramQuery$data;
  variables: HomeInstagramQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bannerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeBanner"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instagramId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageName"
},
v4 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "namePath.0",
        "variableName": "pageName"
      }
    ],
    "kind": "ListValue",
    "name": "namePath"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playlistUrl",
  "storageKey": null
},
v13 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": "banners",
  "args": [
    {
      "kind": "Literal",
      "name": "banner",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "ready",
      "value": true
    }
  ],
  "concreteType": "PageFile",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": "files(banner:true,ready:true)"
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "instagramId",
      "variableName": "instagramId"
    }
  ],
  "concreteType": "InstagramAccount",
  "kind": "LinkedField",
  "name": "instagramAccount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InstagramMedia",
      "kind": "LinkedField",
      "name": "media",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "permalink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bannerId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeInstagramQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v15/*: any*/),
      {
        "condition": "includeBanner",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "banner",
            "args": (v16/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "file",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeInstagramQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v14/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v15/*: any*/),
      {
        "condition": "includeBanner",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "banner",
            "args": (v16/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "file",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9146c2457cac4c9f0ee20795dbe00fe8",
    "id": null,
    "metadata": {},
    "name": "HomeInstagramQuery",
    "operationKind": "query",
    "text": "query HomeInstagramQuery(\n  $instagramId: String!\n  $pageName: String!\n  $includeBanner: Boolean!\n  $bannerId: ID!\n) {\n  page(namePath: [$pageName]) {\n    title\n    titleColor\n    content\n    banners: files(banner: true, ready: true) {\n      id\n      contentType\n      width\n      height\n      playlistUrl\n    }\n    id\n  }\n  instagramAccount(instagramId: $instagramId) {\n    media {\n      id\n      permalink\n      timestamp\n    }\n  }\n  banner: file(id: $bannerId) @include(if: $includeBanner) {\n    __typename\n    id\n    contentType\n    width\n    height\n    playlistUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "f48549e370bf4cce22d2c72de936bfa1";

export default node;
